export const LANDING_PLAN_TYPES = [
  { value: "unis", label: "UNIS" },
  { value: "bips", label: "BIPS" },
  { value: "universitario", label: "UNIVERSITARIO" },
  { value: "nodocente", label: "NODOCENTE" },
  { value: "estatal", label: "ESTATAL" },
  { value: "otro", label: "OTRO" },
];

export const LANDING_PLAN_TYPE_VALUES = LANDING_PLAN_TYPES.map(
  (type) => type.value
);

export function getLandingPlanTypeLabel(value) {
  const type = LANDING_PLAN_TYPES.find((item) => item.value === value);

  return type ? type.label : value || "-";
}
